
import {TokenCredentials} from '../login/tokencredentials';

export class TaskSearch {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    
    name : string;
    descr : string;
    priority: number;
    task : string;

    matches : TaskSearchMatch[];
    filters : TaskSearchFilter[];

    created : Date;
    updated : Date;
}

export class TaskSearchMatch {
    id : number;

    field : string;
    comparator : string;
    expression : string;

    created : Date;
    updated : Date;
}

export class TaskSearchFilter {
    id : number;
    
    field : string;
    comparator : string;
    expression : string;

    created : Date;
    updated : Date;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/task/task-search.ts